import script from "./StockDocumentType.vue?vue&type=script&setup=true&lang=js"
export * from "./StockDocumentType.vue?vue&type=script&setup=true&lang=js"

import "./StockDocumentType.vue?vue&type=style&index=0&id=14261949&lang=css"

const __exports__ = script;

export default __exports__